import { ADD_USER,ADD_TOKEN,ADD_GRADES,ADD_MARKED_SCRIPTS,ADD_ASSIGNED_SCRIPTS,ADD_SELECTED_SUBJECT, ADD_AVAILABLE_SCRIPTS, ADD_USERS } from "../constants/action-types";

const initialState = {
  user: {},
  grades:[],
  assigned_scripts:[],
  available_scripts:[],
  marked_scripts:[],
  access_token:'',
  subject_selected:'',
  users:[]
};

function rootReducer(state = initialState, action) {
    if (action.type === ADD_USER) {
      {
        // //console.log("adding user to redux store",action.payload);
        state.user = action.payload.user;        
      }
    }else if (action.type === ADD_GRADES) {
      {
        // //console.log("adding grades to redux store",action.payload);
        return Object.assign({}, state, {
          grades: state.grades.concat(action.payload)
        });     
      }
    }
    else if (action.type === ADD_AVAILABLE_SCRIPTS) {
      {
        // //console.log("adding available scripts to redux store",action.payload);
        state.available_scripts = action.payload    
      }
    }
    else if (action.type === ADD_ASSIGNED_SCRIPTS) {
      {
        // //console.log("adding assigned scripts to redux store",action.payload);
        state.assigned_scripts = action.payload     
      }
    }else if (action.type === ADD_MARKED_SCRIPTS) {
      {
        // //console.log("adding marked scripts to redux store",action.payload);
        state.marked_scripts = action.payload;   
      }
    }else  if (action.type === ADD_TOKEN) {
      state.access_token = action.payload;
    }else  if (action.type === ADD_SELECTED_SUBJECT) {
      state.subject_selected = action.payload;
    }else  if (action.type === ADD_USERS) {
      {
        //console.log("adding assigned users to redux store",action.payload);
        return Object.assign({}, state, {
          users: state.users.concat(action.payload)
        });     
      }   
    }
    return state;
  }

export default rootReducer;